import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/ui/styles/base.css';
import { App } from './App';

// Safari (iPhone, iPad, Mac trackpad) zooms the whole page on a pinch and ignores user-scalable: a pinch over the
// panels must not blow the game up. The room has its own pinch zoom (CameraGestures).
for (const type of ['gesturestart', 'gesturechange']) {
  document.addEventListener(type, (e) => {
    e.preventDefault();
  });
}

const root = document.getElementById('root');
if (!root) throw new Error('#root missing in index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
